<template>
  <div class="kibiki">
    <h3>忌引き届</h3>
    <template v-if="form.kibiki">
      <div class="delete-table">
        <div class="multi-date-table">

          <div class="item">
            <b class="required">取得日</b>
            <date-picker v-model="form.kibiki.kibiki_start_date"
              :error="getError(form.kibiki, 'kibiki_start_date')"></date-picker>
          </div>

          <div class="item full-width">
            <div class="work-time">
              <koyouKeiyakuTimeSelect :koyouKeiyakuId="koyouKeiyakuId" :targetDate="form.kibiki.kibiki_start_date"
                :workTimeId="workTimeId" @change="changeKoyouKeiyakuTime">
              </koyouKeiyakuTimeSelect>
            </div>
          </div>

          <div class="item" v-if="form.shinsei_koyou_keiyaku_time && selectedSyuugyouBasyoWithKoyouKeiyakuOption">
            <b class="required">区分（取得時間）</b>
            <div class="kibiki-kubun">
              <select-box :options="getKibikiTaniOption()" v-model="form.kibiki.kibiki_tani_type"
                :error="getError(form.kibiki, 'kibiki_tani_type')" :hasBlank="false"></select-box>
              <p>（{{ getKibikiTime(form.kibiki.kibiki_tani_type,
                selectedSyuugyouBasyoWithKoyouKeiyakuOption.sashihiki_times) }}時間）</p>
            </div>
          </div>
        </div>
      </div>

      <div class="item">
        <b class="title required">故人氏名</b>
        <input-text type="text" v-model="form.kibiki.kojin_name"
          :error="getError(form.kibiki, 'kojin_name')"></input-text>
      </div>

      <div class="item">
        <b class="title">よみがな（故人氏名）</b>
        <input-text type="text" v-model="form.kibiki.kojin_kana"
          :error="getError(form.kibiki, 'kojin_kana')"></input-text>
      </div>

      <div class="item">
        <b class="title required">続柄</b>
        <input-text type="text" v-model="form.kibiki.tsuzukigara"
          :error="getError(form.kibiki, 'tsuzukigara')"></input-text>
      </div>

      <div class="item">
        <b class="title required">死去した日付</b>
        <date-picker v-model="form.kibiki.sikyo_date" :error="getError(form.kibiki, 'sikyo_date')"></date-picker>
      </div>

      <!-- MEDICA_AS-1212 対応 -->
      <!-- <div class="item">
      <b class="title">通夜の日付</b>
      <date-picker v-model="form.kibiki.tsuya_date" :error="getError(kibiki, 'tsuya_date')"></date-picker>
    </div>
    <div class="item">
      <b class="title">告別式の日付</b>
      <date-picker v-model="form.kibiki.kokubetsushiki_date" :error="getError(kibiki, 'kokubetsushiki_date')"></date-picker>
    </div>
    <div class="item">
      <b class="title">会場名</b>
      <input-text type="text" v-model="form.kibiki.kaijou_name" :error="getError(kibiki, 'kaijou_name')"></input-text>
    </div>
    <div class="item">
      <b class="title">会場住所</b>
      <input-text type="text" v-model="form.kibiki.kaijou_address" :error="getError(kibiki, 'kaijou_address')"></input-text>
    </div>
    <div class="item">
      <b class="title">会場TEL</b>
      <input-text type="text" v-model="form.kibiki.kaijou_tel" @blur="form.kibiki.kaijou_tel = ConvertUtil.removeNonNumeric(form.kibiki.kaijou_tel, true)" :error="getError(kibiki, 'kaijou_tel')"></input-text>
    </div> -->

      <div class="item">
        <b class="title">備考</b>
        <input-textarea v-model="form.notes" :error="getError(form.kibiki, 'notes')"></input-textarea>
      </div>
    </template>

    <div class="item label">
      近親者に不幸があった場合、申請により、次のとおり忌引休暇を付与します。
    </div>
    <div class="item label">
      ＜忌引き日数＞
    </div>
    <div class="search-result">
      <table>
        <thead>
        </thead>
        <tbody>
          <tr>
            <td class="name">
              <span>配偶者・子</span>
            </td>
            <td class="name">
              <span>3日以内</span>
            </td>
          </tr>
          <tr>
            <td class="name">
              <span>父・母</span>
            </td>
            <td class="name">
              <span>3日以内</span>
            </td>
          </tr>
          <tr>
            <td class="name">
              <span>兄弟</span>
            </td>
            <td class="name">
              <span>3日以内</span>
            </td>
          </tr>
          <tr>
            <td class="name">
              <span>祖父母</span>
            </td>
            <td class="name">
              <span>2日以内</span>
            </td>
          </tr>
          <tr>
            <td class="name">
              <span>配偶者の両親</span>
            </td>
            <td class="name">
              <span>3日以内</span>
            </td>
          </tr>
          <tr>
            <td class="name">
              <span>配偶者の祖父母・兄弟（同居）</span>
            </td>
            <td class="name">
              <span>2日以内</span>
            </td>
          </tr>
          <tr>
            <td class="name">
              <span>配偶者の祖父母・兄弟（別居）</span>
            </td>
            <td class="name">
              <span>無 し</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="item label">
      <p class="underline">※いずれも亡くなった日を含めての連続した日数とします。（土曜日・日曜日も含む。）</p>
    </div>
    <div class="item label">
      【注意事項】
    </div>
    <div class="item label">
      ■亡くなられたことを確認できる書類（会葬礼状等）を写真に撮り、本社総務までメール送付をお願い致します。
    </div>
    <div class="item">
      総務メールアドレス：soumu@medica-staff.com
    </div>
    <div class="item label">
      ■既定の忌引日数を超えて休む場合は、欠勤または有給休暇となりますので、別途申請願います。
    </div>


  </div>
</template>

<script lang="ts">

import { defineComponent, toRefs, ref, Ref, onMounted, nextTick } from "vue";
import { useForm } from '@/composable/form/form';
import OptionConst from '@/const/Option';
import { Shinsei, ShinseiKoyouKeiyakuTime } from '@/types/Shinsei';
import dayjs from "dayjs";
import { KoyouKeiyakuTimeSelectEmitData, SyuugyouBasyoAndKoyouKeiyakuOption } from "@/types/SyuugyouBasyo";
import KoyouKeiyakuTImeSelect from "@/components/shinsei/create/parts/KoyouKeiyakuTimeSelect.vue";
import { ConvertUtil } from "@/utils/ConvertUtil";
import { DateUtil } from "@/utils/DateUtil";
import { Logger } from "@/utils/Logger";
import { useSyuugyouBasyoInit } from "@/composable/syuubyoubasyo/init";
import { KoyouKeiyakuTimeAndHayabanOsobanOption } from "@/types/KoyouKeiyakuTime";

export default defineComponent({
  props: {
    form: {
      type: Object as () => Shinsei,
      default: null
    },
  },
  emits: {
    changeKoyouKeiyakuTime: (selectedSyuugyouBasyo: SyuugyouBasyoAndKoyouKeiyakuOption | null, selectedKoyouKeiyakuTimeOption: ShinseiKoyouKeiyakuTime | null) => true,
  },
  setup(props, context) {
    const { form } = toRefs(props);
    const { selectedSyuugyouBasyoWithKoyouKeiyakuOption } = useSyuugyouBasyoInit()

    // エラー取得
    const { getError } = useForm();

    // 編集モードで使用する就業場所（雇用契約）と就業時間の初期値
    // 初期化時のみ使用し、以降は使用せずnullにする（実データはリクエストで送信される申請オブジェクト内に保持されるため）
    let workTimeId: Ref<number | null> = ref(null)
    let koyouKeiyakuId: Ref<number | null> = ref(null)

    // 選択中の就業場所／就業時間等（MEDICA_AS-959対応）
    const hayabanOsobanOpt: Ref<KoyouKeiyakuTimeAndHayabanOsobanOption[]> = ref([])
    const sashihikiTimes: Ref<string | null> = ref(null)

    const isInit = ref(false)

    onMounted(async () => {
      Logger.debug('----------------------------\n時間外申請コンポーネントの初期化開始')
      Logger.debug('時間外申請 onMounted', { '申請': form.value })
      nextTick(() => {
        Logger.debug('時間外申請 onMounted->nextTick', { '申請': form.value })
        if (!form.value.kibiki) {
          Logger.debug('新規作成モードの初期化を行います')
          form.value.kibiki = {
            kibiki_start_date: null,
            kibiki_tani_type: null,
            kibiki_times: null,
            kojin_name: null,
            kojin_kana: null,
            tsuzukigara: null,
            kokubetsushiki_date: null,
            kaijou_address: null,
            sikyo_date: null,
            tsuya_date: null,
            kaijou_name: null,
            kaijou_tel: null
          }
        } else {
          Logger.debug('編集モードの初期化を行います')
          workTimeId.value = form.value.shinsei_koyou_keiyaku_time.length > 0 ? form.value.shinsei_koyou_keiyaku_time[0].koyou_keiyaku_time_id : null
          koyouKeiyakuId.value = form.value.koyou_keiyaku_id ?? null
          Logger.debug('時間外申請より就業場所（雇用契約）と就業時間を初期化しました', { '雇用契約ID': koyouKeiyakuId.value, '就業時間ID': workTimeId.value })
        }
        isInit.value = true
        Logger.debug('時間外申請コンポーネントの初期化完了\n----------------------------')
      })
    })

    // 忌引き取得時間の計算
    // @type 1:1日、2:AM休, 3:PM休
    // @time 雇用契約の有休差し引き時間
    // @index 選択した行
    const getKibikiTime = (type: number | null, time: string | null) => {
      if (!form.value.kibiki) return

      let resTime
      if (!type || !time) {
        return '0.00'
      }

      // 雇用契約の有休差し引き時間が指定されている場合、第1位優先度で差し引き時間を使用する。
      if (time != "00:00:00") {

        // 申請の送信用データに設定
        let res = getDateTimeObject(String(time))
        form.value.kibiki.kibiki_times = res.format('HH:mm')

        return (res.hour() + res.minute() / 60).toFixed(2);
      }

      // 雇用契約の有休差し引き時間が指定されていない場合、就業時間の通常時間を使用する。

      // 就業時間レコードが取得できない場合
      let shinsei_koyou_keiyaku_time_count = form.value.shinsei_koyou_keiyaku_time.length
      if (shinsei_koyou_keiyaku_time_count == 0) {
        return '0.00'
      }

      // 取得日を未選択で、忌引き申請レコードの就業時間(shinsei_koyou_keiyaku_time)を未設定の場合
      if (shinsei_koyou_keiyaku_time_count < 1) {
        return '0.00'
      }

      // 就業時間の通常勤務時間が取得できない場合
      if (!form.value.shinsei_koyou_keiyaku_time[0].tsuujouTime) {
        return '0.00'
      }

      // 就業時間レコードの就業時間の通常時間が00:00:00の場合
      if (form.value.shinsei_koyou_keiyaku_time[0].tsuujouTime == "00:00:00") {
        form.value.kibiki.kibiki_times = "00:00"
        return '0.00'
      }


      // console.log('workTimeEle')
      // console.log(workTimeEle)

      // 早番遅番申請が出ているかどうか
      let canShinseiDivAllForHayabanOsoban = false;

      if (hayabanOsobanOpt.value) {
        // 対象日に早番遅番申請が出ている場合、一致する早番遅番の情報を取得
        const matchedayabanOsobanOption = hayabanOsobanOpt.value.filter((v: any) => v.date === DateUtil.format(form.value.kibiki!.kibiki_start_date?.toString(), 'YYYY/MM/DD'))

        if (matchedayabanOsobanOption.length > 0) {
          // 早番遅番申請が提出されている場合、全ての取得区分（1日、AM休、PM休）を選択可能とする
          canShinseiDivAllForHayabanOsoban = true
        }
      }

      // AM休しか取得できないかどうかのフラグを取得できる場合
      let canOnlyAmKinmu = form.value.shinsei_koyou_keiyaku_time[0].canOnlyAmKinmu
      // PM休しか取得できないかどうかのフラグを取得できる場合
      let canOnlyPmKinmu = form.value.shinsei_koyou_keiyaku_time[0].canOnlyPmKinmu

      let isHannichi = form.value.shinsei_koyou_keiyaku_time[0].isHannichi
      if ((!isHannichi && !canOnlyAmKinmu && !canOnlyPmKinmu && !canShinseiDivAllForHayabanOsoban) && (type == 2 || type == 3)) {
        // if((!isHannichi && !canOnlyAmKinmu && !canOnlyPmKinmu) && (type == 2 || type == 3)){
        form.value.kibiki.kibiki_times = "00:00"
        return '0.00'
      }

      // 忌引き取得日の就業時間の通常時間
      let tsuujouTime = form.value.shinsei_koyou_keiyaku_time[0].tsuujouTime

      const nowYMD = dayjs().format('YYYY/MM/DD')

      const kibikiTime = dayjs(nowYMD + ' ' + tsuujouTime)

      // console.log('kibikiTime');
      // console.log(kibikiTime);

      // 取得する忌引き取得時間を1日、AM休、PM休で分ける
      if (isHannichi) {
        // 半日取得可の場合

        if (type == OptionConst.SHINSEI_DIV.FULL_DAY) {
          // 選択した取得区分タイプが1日休の場合
          resTime = kibikiTime
        } else {
          // 選択した取得区分タイプがAM休、PM休の場合
          let half = kibikiTime.subtract(4, 'h')
          // 4時間差し引き後の値と差引前の時間の差がマイナスになる場合
          // 3:00 - 4:00 = 23:00 等のケース
          if (kibikiTime.format('HH:mm') <= half.format('HH:mm')) {
            form.value.kibiki.kibiki_times = "00:00"
            return '0.00'
          } else {
            resTime = half
          }
        }

      } else {

        // AM休しか取得できないかどうかのフラグを取得できる場合
        let canOnlyAmKinmu = form.value.shinsei_koyou_keiyaku_time[0].canOnlyAmKinmu
        // PM休しか取得できないかどうかのフラグを取得できる場合
        let canOnlyPmKinmu = form.value.shinsei_koyou_keiyaku_time[0].canOnlyPmKinmu

        if (canOnlyAmKinmu) {
          // AM休しか取得できない
          resTime = kibikiTime
        } else if (canOnlyPmKinmu) {
          // PM休しか取得できない
          resTime = kibikiTime
        } else {
          // 1日休のみの場合
          resTime = kibikiTime
        }

      }

      // 早番遅番申請が出ている場合
      if (canShinseiDivAllForHayabanOsoban) {

        if (type == OptionConst.SHINSEI_DIV.FULL_DAY) {
          // 選択した取得区分タイプが1日休の場合
          resTime = kibikiTime
        } else {
          // 選択した取得区分タイプがAM休、PM休の場合
          let half = kibikiTime.subtract(4, 'h')
          // 4時間差し引き後の値と差引前の時間の差がマイナスになる場合
          // 3:00 - 4:00 = 23:00 等のケース
          if (kibikiTime.format('HH:mm') <= half.format('HH:mm')) {
            form.value.kibiki.kibiki_times = "00:00"
            return '0.00'
          } else {
            resTime = half
          }
        }

      }

      // 申請の送信用データに設定
      form.value.kibiki.kibiki_times = resTime.format('HH:mm')

      // 画面表示用の忌引き休取得時間の値を返す
      return (resTime.hour() + (Number(resTime.minute()) / 60)).toFixed(2)
    }

    const getDateTimeObject = (time: string) => {
      const nowYMD = dayjs().format('YYYY/MM/DD')
      return dayjs(nowYMD + ' ' + time)
    }

    // 就業場所・就業時間が変更された場合に走る処理
    // 引数は以下コンポーネントのemits.changeに準拠
    // src/resources/ts/components/shinsei/create/parts/KoyouKeiyakuTimeSelect.vue
    const changeKoyouKeiyakuTime = (emitData: KoyouKeiyakuTimeSelectEmitData) => {
      Logger.debug('申請雇用契約時間をもとに申請雇用契約時間のセットをします', emitData)
      if (!form.value.kibiki) return // 親コンポーネントにて必ずform.value.yuukyuuは初期化しているので形チェックエラー回避のため

      hayabanOsobanOpt.value = emitData.koyouKeiyakuTimeAndHayabanOsobanOptions.hayabanOsobanOpt
      sashihikiTimes.value = emitData.koyouKeiyakuTimeAndHayabanOsobanOptions.sashihikiTime
      workTimeId.value = emitData.selectedKoyouKeiyakuTimeOption?.val ?? null

      form.value.kibiki.kibiki_tani_type = null;

      // このコンポーネント内で使用するためコンポーネント内の変数に保持
      selectedSyuugyouBasyoWithKoyouKeiyakuOption.value = emitData.selectedSyuugyouBasyo

      // 就業時間に関する情報のセット
      let koyouKeiyakuTime: ShinseiKoyouKeiyakuTime | null = null

      // 通常勤務時間
      let tsuujouTime: string | null = "00:00:00"
      // 半日休取得可能かどうかのフラグ
      let isHannichi = false
      // AM休しか取得できない、指定した通常時間が忌引き取得時間
      let canOnlyAmKinmu = 0
      // PM休しか取得できない、指定した通常時間が忌引き取得時間
      let canOnlyPmKinmu = 0


      if (emitData.selectedKoyouKeiyakuTimeOption) {

        // 通常勤務時間を取得できる場合
        if (emitData.selectedKoyouKeiyakuTimeOption.tsuujouTime) {
          tsuujouTime = emitData.selectedKoyouKeiyakuTimeOption.tsuujouTime
        }

        // 半日休取得可能かどうかのフラグを取得できる場合
        if (emitData.selectedKoyouKeiyakuTimeOption.isHannichi) {
          isHannichi = emitData.selectedKoyouKeiyakuTimeOption.isHannichi
        }

        // AM休しか取得できないかどうかのフラグを取得できる場合
        if (emitData.selectedKoyouKeiyakuTimeOption.canOnlyAmKinmu) {
          canOnlyAmKinmu = emitData.selectedKoyouKeiyakuTimeOption.canOnlyAmKinmu
          tsuujouTime = emitData.selectedKoyouKeiyakuTimeOption.tsuujouTime
        }

        // PM休しか取得できないかどうかのフラグを取得できる場合
        if (emitData.selectedKoyouKeiyakuTimeOption.canOnlyPmKinmu) {
          canOnlyPmKinmu = emitData.selectedKoyouKeiyakuTimeOption.canOnlyPmKinmu
          tsuujouTime = emitData.selectedKoyouKeiyakuTimeOption.tsuujouTime
        }

        // 忌引き申請で使用する雇用契約時間にデータを保存する
        koyouKeiyakuTime = {
          shinsei_id: form.value.shinsei_id,
          koyou_keiyaku_time_id: emitData.selectedKoyouKeiyakuTimeOption.val,
          target_date: form.value.kibiki.kibiki_start_date,
          tsuujouTime: tsuujouTime,
          isHannichi: isHannichi,
          canOnlyAmKinmu: canOnlyAmKinmu,
          canOnlyPmKinmu: canOnlyPmKinmu,
        }
      }

      // 就業場所に関する情報をemitする（申請オブジェクトの変更等は親に移譲する）
      context.emit('changeKoyouKeiyakuTime', emitData.selectedSyuugyouBasyo, koyouKeiyakuTime);
    }

    // @selectedKoyou
    // const getKoyouKeiyakuTimeId = (date: string | Date | null) => {
    //   const d = dayjs(date)
    //   return form.value.shinsei_koyou_keiyaku_time?.find(function (v, k) {
    //     return d.isSame(v.target_date)
    //   })?.koyou_keiyaku_time_id
    // }

    // const koyouKeiyakuId = computed(() => {
    //   return selectSyuugyouBasyo.value ? selectSyuugyouBasyo.value.koyou_id : null
    // })

    // 取得区分の1日、AM休、PM休のセレクトボックス値を取得
    const getKibikiTaniOption = () => {
      let canShinseiDivAllForHayabanOsoban = false

      if (hayabanOsobanOpt.value) {
        let matchedayabanOsobanOption = hayabanOsobanOpt.value.filter((v: any) => v.date === DateUtil.format(form.value.kibiki?.kibiki_start_date?.toString(), 'YYYY/MM/DD'))

        if (matchedayabanOsobanOption.length > 0) {
          // 申請の1日、AM休、PM休を選択可能とする
          canShinseiDivAllForHayabanOsoban = true
        }
      }

      if (canShinseiDivAllForHayabanOsoban) {
        // 申請の1日、AM休、PM休を選択可能とする
        return OptionConst.SHINSEI_DIV_OPTION
      }

      // 雇用契約の有休差引時間が設定されている場合
      if (sashihikiTimes.value !== "00:00:00") {
        // 1日申請のみ可能
        return OptionConst.SHINSEI_DIV_OPTION.filter(
          (v) => v.val === OptionConst.SHINSEI_DIV.FULL_DAY
        )
      }

      // 就業時間未選択時
      if (!form.value.shinsei_koyou_keiyaku_time[0]) {
        // 取得区分の1日、AM休、PM休を選択可能とする
        return OptionConst.SHINSEI_DIV_OPTION
      }

      // 半日申請可能な場合
      if (form.value.shinsei_koyou_keiyaku_time[0].isHannichi) {
        // 取得区分の1日、AM休、PM休を選択可能とする
        return OptionConst.SHINSEI_DIV_OPTION

      } else {
        // AM休しか取得できないかどうかのフラグを取得できる場合
        if (form.value.shinsei_koyou_keiyaku_time[0].canOnlyAmKinmu) {
          return OptionConst.SHINSEI_DIV_OPTION.filter(
            (v) => v.val === OptionConst.SHINSEI_DIV.AM
          )
        }

        // PM休しか取得できないかどうかのフラグを取得できる場合
        if (form.value.shinsei_koyou_keiyaku_time[0].canOnlyPmKinmu) {
          return OptionConst.SHINSEI_DIV_OPTION.filter(
            (v) => v.val === OptionConst.SHINSEI_DIV.PM
          )
        }

        // 1日休のみ可能な場合
        return OptionConst.SHINSEI_DIV_OPTION.filter(
          (v) => v.val === OptionConst.SHINSEI_DIV.FULL_DAY
        )
      }
    }

    return {
      getError,
      'kyuukaDiv': OptionConst.SHINSEI_DIV_OPTION,
      changeKoyouKeiyakuTime,
      getKibikiTime,
      koyouKeiyakuId,
      workTimeId,
      getKibikiTaniOption,
      ConvertUtil,
      selectedSyuugyouBasyoWithKoyouKeiyakuOption
    }
  },
  components: {
    'koyouKeiyakuTimeSelect': KoyouKeiyakuTImeSelect
  }
})

</script>
<style lang="scss" scoped>
@import '@scss/components/shinsei-create.scss';
</style>